/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
// import firebase from "firebase/app";
import "firebase/storage";
// import { useSelector } from "react-redux";
import { Button, List, Header, Icon, Menu, Modal } from "semantic-ui-react";

function PdfModal({ value, ...item }) {
  const [open, setOpen] = useState(false);
  // const uid = useSelector((state) => state.firebase.auth.uid);

  // const handleUpload = async () => {
  //   const { PDFDocument } = require("pdf-lib");

  //   const formName = value;

  //   const currentTime = await new Date();

  //   const formPdfBytes = await global
  //     .fetch(value.fileUrl, {
  //       contentType: "application/x-www-form-urlencoded",
  //     })
  //     .then((res) => res.arrayBuffer());

  //   const storageRef = await firebase
  //   .storage()
  //   .ref(`autoFill/${uid}/${formName}.pdf`);

  //   // const Pdfbytes = new Uint8Array([
  //   //   0x48, 0x65, 0x6c, 0x6c, 0x6f, 0x2c, 0x20, 0x77, 0x6f, 0x72, 0x6c, 0x64,
  //   //   0x21,
  //   // ]);

  //   // uploadBytes(storageRef, Pdfbytes).then((snapshot) => {
  //   //   console.log("Uploaded an array!");
  //   // });

  //   const pdfDoc = await PDFDocument.load(formPdfBytes);

  //   const pdfBytes = await pdfDoc.save();



  //   await storageRef
  //     .put(pdfBytes, {
  //       contentType: "application/pdf",
  //     })
  //     // eslint-disable-next-line no-loop-func
  //     .catch((err) => {
  //       global.alert(err);
  //     });

  //   await firebase
  //     .firestore()
  //     .collection("documentList")
  //     .doc(uid)
  //     .collection("owner")
  //     .doc(formName)
  //     .set(
  //       {
  //         editionDate: currentTime,
  //       },
  //       { merge: true }
  //     );

  //   await global.alert("Successfull");
  // };
  return (
    <Modal
      centered={false}
      open={open}
      style={{
        minHeight: "100%",
        minWidth: "100%",
        marginTop: "-5px",
      }}
      size="fullscreen"
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      trigger={
        <List.Item key={value.fileName}>
          <List.Icon
            color="red"
            name="github"
            size="large"
            verticalAlign="middle"
          />
          <List.Content>
            <List.Header as="a">{value.fileName.split("_")[1]}.pdf</List.Header>
          </List.Content>
        </List.Item>
      }
    >
      <div>
        <Menu>
          {" "}
          <Menu.Menu position="left">
            <Header style={{ marginTop: "5px", marginLeft: "5px" }}>
              {`${value.fileName.split("_")[1]}`}
            </Header>
          </Menu.Menu>
          <Menu.Menu position="right">
            {/* <Button animated floated="right" onClick={() => handleUpload()}>
              <Button.Content visible>Save to Cloud</Button.Content>
              <Button.Content hidden>
                <Icon name="cloud upload" />
              </Button.Content>
            </Button> */}
            <Button
              animated="vertical"
              floated="right"
              onClick={() => setOpen(false)}
            >
              <Button.Content visible>Back</Button.Content>
              <Button.Content hidden>
                <Icon name="arrow right" />
              </Button.Content>
            </Button>
          </Menu.Menu>
        </Menu>
      </div>
      <iframe
        title={value.fileName}
        src={`${value.fileUrl}&embedded=true`}
        style={{
          position: "absolute",
          top: "%5",
          left: 0,
          bottom: 0,
          right: 0,
          width: "100%",
          height: "95%",
        }}
      ></iframe>
    </Modal>
  );
}

export default PdfModal;
